export const DEFAULT_NAME = 'rate'
export const LEVELS = 5
